// Il DB crea una riga in session_responses solo quando qualcuno risponde: chi
// non risponde non ha nessuna riga. Qui le mancanze diventano righe no_response,
// cosi' conteggi e Squad Score ragionano tutti sulla stessa base.
import { isSquadPlayer } from "./roster";
import type { Player, Session, SessionResponse } from "../types";

export function withMissingResponses(
  players: Player[],
  sessions: Session[],
  responses: SessionResponse[],
  now = Date.now(),
): SessionResponse[] {
  const answered = new Set(responses.map((r) => `${r.session_id}|${r.player_id}`));
  const roster = players.filter(isSquadPlayer);
  const missing: SessionResponse[] = [];
  for (const session of sessions) {
    const startsAt = new Date(session.starts_at).getTime();
    if (startsAt >= now || session.status === "draft" || session.status === "cancelled") continue;
    for (const player of roster) {
      if (player.created_at && new Date(player.created_at).getTime() > startsAt) continue;
      if (answered.has(`${session.id}|${player.id}`)) continue;
      missing.push({
        id: `missing:${session.id}:${player.id}`,
        session_id: session.id,
        player_id: player.id,
        status: "no_response",
        source: "missing",
        session_starts_at: session.starts_at,
        session_title: session.title,
        session_has_matches: session.has_matches,
        season_id: session.season_id,
      });
    }
  }
  return missing.length > 0 ? [...responses, ...missing] : responses;
}
